/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import noUiSlider from "nouislider";
import wNumb from "wnumb";

/*------------------------------------*\
    RANGE SLIDER MODULE
\*------------------------------------*/
class RangeSlider {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var elem = $(this);

        var fieldName = elem[0].elem.dataset.fieldName,
            direction = elem[0].elem.dataset.direction,
            max = Number(elem[0].elem.dataset.rangeMax),
            min = Number(elem[0].elem.dataset.rangeMin),
            step = Number(elem[0].elem.dataset.step),
            decimals = elem[0].elem.dataset.decimals,
            hasDuplicateField = elem[0].elem.dataset.hasDuplicateField,
            connect,
            start,
            parent = elem.closest('.js-range-slider'),
            //minMetaContainer = parent.siblings('.js-range-slider-meta').find('.js-range-slider-meta--min'),
            //maxMetaContainer = parent.siblings('.js-range-slider-meta').find('.js-range-slider-meta--max'),
            minMetaContainer = document.getElementById('meta-min-' + fieldName),
            maxMetaContainer = document.getElementById('meta-max-' + fieldName),
            //minMetaValueContainer = parent.siblings('.js-range-slider-meta').find('.js-range-slider-meta--min__value'),
            //maxMetaValueContainer = parent.siblings('.js-range-slider-meta').find('.js-range-slider-meta--max__value'),
            minMetaValueContainer = document.getElementById('meta-min-value-' + fieldName),
            maxMetaValueContainer = document.getElementById('meta-max-value-' + fieldName),
            inputField = document.getElementById(fieldName);
            //inputField = parent.siblings('.js-range-slider-input');

        // Work out the direction of the slider
        if (direction === 'greaterThan') {
            connect = [false, true];
            start = min;
        }
        else {
            connect = [true, false];
            start = max;
        }

        // If the slider start position has been specified (as a data
        // attribute), use that value instead of the min or max values
        if (elem[0].elem.dataset.start) {
            start = elem[0].elem.dataset.start;
        }

        // Create the range slider
        noUiSlider.create(self.elem, {
            start: start,
            connect: connect,
            range: {
                'min': min,
                'max': max
            },
            step: step,
            format: wNumb({
                decimals: decimals,
                encoder: function (val) {
                    // This function ACTUALLY rounds the number to the specified decimal places,
                    // because the 'decimals' parameter above apparently doesn't work very well.
                    return Math.round(val * 100) / 100;
                }
            })
        });

        // While the handle is being dragged, make it orange
        self.elem.noUiSlider.on('start', function () {
            elem[0].elem.classList.add('is-active');
            //elem.addClass('is-active');
        });

        self.elem.noUiSlider.on('end', function () {
            elem[0].elem.classList.remove('is-active');
            //elem.removeClass('is-active');
        });

        // When a slider is changed...
        self.elem.noUiSlider.on('update', function (values, handle) {
            // If the slider is not at min (for 'greater than') or max (for 'less than')...
            if ((direction === 'greaterThan' && values[handle] != min) || (direction === 'lessThan' && values[handle] != max)) {
                // Change the bar color to orange
                elem[0].elem.classList.add('is-populated');
                //elem.addClass('is-populated');

                // Add the is-active class to the meta value
                if (direction === 'greaterThan') {
                    minMetaContainer.classList.add('is-active');
                    //minMetaContainer.addClass('is-active');
                }
                else {
                    maxMetaContainer.classList.add('is-active');
                    //maxMetaContainer.addClass('is-active');
                }

                // If the field has a duplicate in the primary fields (dropdowns) section
                if (hasDuplicateField) {
                    // Get the related dropdown
                    var relatedDropdown = $('.js-primary-filter-dropdown[data-related-field="' + fieldName + '"]');

                    // Get the values of the dropdown
                    var dropdownValues = relatedDropdown.children('option').map(function () {
                        return $(this).val();
                    }).get();

                    // If the slider value matches an item in the dropdown
                    if ($.inArray(values[handle], dropdownValues) > -1) {
                        // Enable the dropdown
                        relatedDropdown.prop('disabled', false);
                        relatedDropdown.val(values[handle]);

                        // Remove the title attr
                        relatedDropdown.attr('title', '');
                    }
                    else {
                        // Otherwise, disable the dropdown
                        relatedDropdown.val('').prop('disabled', true);

                        // Remove the title attr
                        relatedDropdown.attr('title', 'Please refer to the filter below');
                    }
                }
            }
            else {
                // Remove the orange bar color
                elem[0].elem.classList.remove('is-populated');
                //elem.removeClass('is-populated');

                // Remove the is-active class from the meta value
                //minMetaContainer.removeClass('is-active');
                minMetaContainer.classList.remove('is-active');
                //maxMetaContainer.removeClass('is-active');
                maxMetaContainer.classList.remove('is-active');

                // If the field has a duplicate in the primary fields (dropdowns) section
                if (hasDuplicateField) {
                    relatedDropdown = $('[data-related-field="' + fieldName + '"]').first();

                    relatedDropdown.prop('disabled', false);

                    // Remove the title attr
                    relatedDropdown.attr('title', '');
                }
            }

            // If it's a 'greater than' slider, update the min value meta label with the new value
            if (direction === 'greaterThan') {
                //minMetaValueContainer.text(values[handle]);
                minMetaValueContainer.textContent = values[handle];
            }

            // If it's a 'less than' slider, update the max value meta label with the new value
            if (direction === 'lessThan') {
                //maxMetaValueContainer.text(values[handle]);
                maxMetaValueContainer.textContent = values[handle];
            }

            // if the slider is a 'greater than' slider and the handle is not at max, show the bar extension
            if (direction === 'greaterThan' && values[handle] != max) {
                elem[0].elem.classList.add('has-bar-extension');
                //elem.addClass('has-bar-extension');

                // if the handle is not at minimum, make the bar extension orange
                if (values[handle] != min) {
                    elem[0].elem.classList.add('has-bar-extension--populated');
                    //elem.addClass('has-bar-extension--populated');
                }
                else {
                    elem[0].elem.classList.remove('has-bar-extension--populated');
                    //elem.removeClass('has-bar-extension--populated');
                }
            }
            else {
                elem[0].elem.classList.remove('has-bar-extension');
                //elem.removeClass('has-bar-extension');
            }

            // Update the input field
            if ((direction === 'greaterThan' && values[handle] != min) || (direction === 'lessThan' && values[handle] != max)) {
                inputField.value = values[handle];
            }
            else {
                inputField.value = '';
            }

        });

        // If the hidden input field value changes, update the slider
        //inputField.on('change', function (evt) {
            //newValue = inputField.value;
            self.elem.noUiSlider.set(inputField.value);
        //});
    }
}

export default RangeSlider;